import {
    Button, Dialog, DialogContent, DialogTitle, Divider, Grid, Paper,
    styled, Table, TableBody, TableCell, tableCellClasses, TableContainer,
    TableHead, TableRow, TextField
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import BillingService from '../../Services/billing/BillingService';
import Home from '../home/Home';
import Snacbar from '../Snacbar';
import { getUserId } from '../Utils/Common';
import HashLoader from "react-spinners/HashLoader";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";
import { ToggleButton } from '@mui/material';
import BillingReportsService from '../../Services/Reports/BillingReportsService';

const jobentrylablestyle = {
    color: 'grey',
    fontWeight: 'bolder',
    fontFamily: 'Times New Roman',
}

const ItemPap = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: '1px solid black',
    height: '400px'
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));
const ItemPap2 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: '1px solid black',
    maxHeight: '200',
    height: '100%',
}));
const ItemPap3 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: theme.palette.text.secondary,
    border: '1px solid black',
}));
const ItemPap4 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'right',
    color: theme.palette.text.secondary,
    border: '1px solid black',
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: 'rgb(61, 195, 177)',
        color: theme.palette.common.black,
        padding: theme.spacing(0.5),
        fontFamily: 'Times New Roman',
        fontWeight: 'bold',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 15,
        color: 'darkblue',
        textAlign: 'center',
        fontFamily: 'Times New Roman',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
}));
function BillAuditing() {
    const [OpenViewJob, setOpenViewJob] = useState(false);
    const [OpenOverAllViewJob, setOpenOverAllViewJob] = useState(false);
    const [OpenJobBillVerified, setOpenJobBillVerified] = useState(false);
    const [nonUplode, setnonUplode] = useState([]);
    const [Filtereddetails, setFiltereddetails] = useState([]);
    const [loading, setloading] = useState(false)
    const [DrpImporter, setDrpImporter] = useState([]);
    const [billName, setbillName] = useState([]);
    const [billType, setbillType] = useState([]);
    const [billPrintTo, setbillPrintTo] = useState([]);
    const [VoucherType, setVoucherType] = useState([]);
    // const [Brannch, setBrannch] = useState([]);
    const [PrintedType, setPrintedType] = useState([]);

    const [BillingQuotationDetails, setBillingQuotationDetails] = useState([]);
    const [BillingCustodian, setBillingCustodian] = useState([]);
    const [PaymentReqPurpose, setPaymentReqPurpose] = useState([]);
    const [AllPayment, setAllPayment] = useState([]);
    const [BillingCustom, setBillingCustom] = useState([]);
    const [BillingSummary, setBillingSummary] = useState([]);
    // const [QuotationBasedOnCustomerType, setQuotationBasedOnCustomerType] = useState([]);
    const [selected, setSelected] = useState([]);
    const [open, setOpen] = useState(false);
    const [severity, setseverity] = useState('');
    const [message, setMessage] = useState('');
    const [consigmnt, setConsigment] = useState('');
    const [BillAuditValues, setBillAuditValues] = useState({
        billid: '', importer: '', jobNo: '', Billname: '',BillPrintTo:'',
        BillPayby: '', BillPayDate: '', BillPaidto: '',
        Paymenttype: '', vouchertype: '', printedtype: '',
        RecVoucherNo: '', BillAmount: '', Remraks: '', gstprcnt: '',
    });
    const [dialogValues, setDialogValues] = useState({
        grossWight: '',
        chargeableWight: ''
    })
    const [BillGenError, setBillGenError] = useState({
        Billname: false, BillPayby: false, Paymenttype: false, vouchertype: false,
        printedtype: false, RecVoucherNo: false, BillAmount: false,
    });
    const [jobentryDetails, setjobentryDetails] = useState({
        txt_asJobNo: '', txt_asMawbNo: '', txt_asImporterName: '', txt_asImporterCode: '', txt_asImporterState: '',
        ta_asimporterAddress: '', txt_asTransitType: '', txt_asAirlinesName: '', txt_asOriginCountry: '', txt_asOriginPort: '',
        txt_asClearancePort: '', txt_asArrivalDate: '', txt_asHawbNo: '', lbl_asMawbNo: 'MAWB.No', lbl_asAirlinesName: 'AirlinesName',
        lbl_asHawbNo: 'HAWB.No',
    })

    const [UpdateDsa, setUpdateDsa] = useState(true);
    const [DeleteDsa, setDeleteDsa] = useState(true);

    const [Update, setUpdate] = useState(false);
    const [Delete, setDelete] = useState(false);

    const [quatetion, setquatetion] = useState('');
    const [expensis, setexpensis] = useState('');
    const [actualExpensis, setactualExpensis] = useState('');
    const [requestEstimetion, setrequestEstimetion] = useState('');

    const BillAudit_importerChangeHandle = (e) => {
        setBillAuditValues({ ...BillAuditValues, importer: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
        getJobNoConsoleNonUpload(e.target.value, BillAuditValues.jobNo);
    }
    const BillAudit_jobNoChangeHandle = (e) => {
        setBillAuditValues({ ...BillAuditValues, jobNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
        var consigmnt, importer_iec_no = '';
        if (e.target.value === '') { consigmnt = '-1' }
        else { consigmnt = e.target.value }
        if (BillAuditValues.importer === '') { importer_iec_no = '-1'; }
        else { importer_iec_no = BillAuditValues.importer; }
        let details = { importer_iec_no: importer_iec_no, consignmentNumber: consigmnt, status: '17' }
        BillingService.getJobNoBasedImpCMNonUploadCL(details).then((res) => { setnonUplode(res.data); setFiltereddetails(res.data) });
    }
    const BillAudit_BillnameChangeHandle = (e) => {
        setBillAuditValues({ ...BillAuditValues, Billname: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const BillAudit_BillPrintToChangeHandle = (e) => {
        setBillAuditValues({ ...BillAuditValues, BillPrintTo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const BillAudit_BillPaybyChangeHandle = (e) => {
        var totalAmmount = parseFloat(e.target.value)*parseFloat(BillAuditValues.BillPaidto);
        setBillAuditValues({ ...BillAuditValues, BillPayby: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ''),BillAmount:parseFloat(totalAmmount).toFixed(2) })
    }
    const BillAudit_BillPayDateChangeHandle = (e) => {
        setBillAuditValues({ ...BillAuditValues, BillPayDate: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const BillAudit_BillPaidtoChangeHandle = (e) => {
        var totalAmmount = parseFloat(e.target.value)*parseFloat(BillAuditValues.BillPayby);
        setBillAuditValues({ ...BillAuditValues, BillPaidto: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ''),BillAmount:parseFloat(totalAmmount).toFixed(2)  })
    }
    const BillAudit_PaymenttypeChangeHandle = (e) => {
        setBillAuditValues({ ...BillAuditValues, Paymenttype: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const BillAudit_vouchertypeChangeHandle = (e) => {
        setBillAuditValues({ ...BillAuditValues, vouchertype: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const BillAudit_printedtypeChangeHandle = (e) => {
        setBillAuditValues({ ...BillAuditValues, printedtype: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const BillAudit_RecVoucherNoChangeHandle = (e) => {
        setBillAuditValues({ ...BillAuditValues, RecVoucherNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const BillAudit_BillAmountChangeHandle = (e) => {
        setBillAuditValues({ ...BillAuditValues, BillAmount: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const BillAudit_RemraksChangeHandle = (e) => {
        setBillAuditValues({ ...BillAuditValues, Remraks: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const BillAudit_gstChangeHandle = (e) => {
        setBillAuditValues({ ...BillAuditValues, gstprcnt: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const chargableChangehandle = (e) => {
        setDialogValues({ ...dialogValues, chargeableWight: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
    }
    //dialogcolseAndOpenEvents
    const CloseViewJobHandle = () => {
        setOpenViewJob(false);
    }
    const OpenViewJobHandle = () => {
        setOpenViewJob(true);
    }
    const CloseOverAllViewJobHandle = () => {
        setOpenOverAllViewJob(false);
    }
    const OpenOverAllViewJobHandle = () => {
        setOpenOverAllViewJob(true);
    }
    const CloseJobBillVerifiedHandle = () => {
        setOpenJobBillVerified(false);
    }
    const OpenJobBillVerifiedHandle = () => {
        if (consigmnt !== '') {
            setOpenJobBillVerified(true);
            getJobWeight();
        } else {
            setOpen(true); setseverity('warning'); setMessage('Kindly select the Non Verification Job No Grid')
        }
    }
    const getJobWeight = () => {
        BillingService.getJobWeight(1, consigmnt).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            setDialogValues({ ...dialogValues, grossWight: lastResult[0].weightIdString, chargeableWight: lastResult[0].chargeableWeight });
        })
    }

    const getData = async () => {
        BillingService.getnonAudit('17').then(res => { setnonUplode(res.data); setFiltereddetails(res.data) });
        // BillingService.getAudit('16').then(res => { setconsoleDetails(res.data); });
    }
    const drpData = () => {
        BillingService.getImporterDetails().then((res) => { setDrpImporter(res.data) });
        BillingService.getbillName('-1').then((res) => { setbillName(res.data); });
        BillingService.getBillPaymentType().then((res) => { setbillType(res.data); });
        // BillingService.getBillPaidBy().then((res) => { setbillPrintTo(res.data); });
        BillingReportsService.getCurrencyName().then((res) => { setbillPrintTo(res.data); });
        BillingService.getVoucherType().then((res) => { setVoucherType(res.data); });
        // BillingService.getRegionalOfficeDetails().then((res) => { setBrannch(res.data); });
        BillingService.getPrintedType().then((res) => { setPrintedType(res.data); });
    }

    useEffect(() => {
        setloading(true)
        setTimeout(() => {
            setloading(false)
        }, 1000)
        const getData = async () => {
            BillingService.getnonAudit('17').then(res => { setnonUplode(res.data); setFiltereddetails(res.data) });
            // BillingService.getAudit('16').then(res => { setconsoleDetails(res.data); });
        }
        getData();
        drpData();
    }, []);


    const getJobNoConsoleNonUpload = (val, val2) => {
        var consigmnt, importer_iec_no = '';
        if (val2 === '') { consigmnt = '-1' }
        else { consigmnt = val2 }
        if (val === '') { importer_iec_no = '-1'; }
        else { importer_iec_no = val; }
        let details = { importer_iec_no: importer_iec_no, consignmentNumber: consigmnt, status: '17' }
        BillingService.getJobNoBasedImpCMNonUploadCL(details).then((res) => { setnonUplode(res.data); setFiltereddetails(res.data) });
        // BillingService.getJobNoBasedImpCMUploadCL(details).then(res => { setconsoleDetails(res.data); });
    }

    const getBillingQuotationDetails = (val) => {
        BillingService.getBillingQuotationDetails(val).then((res) => {
            const data = res.data;
            const billAmount = data.map((item) => item.billAmount);
            let billAmnt = 0;
            for (let i = 0; i < billAmount.length; i++) {
                billAmnt += billAmount[i];
            }
            setBillingQuotationDetails(res.data);
            setquatetion(billAmnt);
        });
    }
    const getBillingCustodian = (val) => {
        BillingService.getBillingCustodian(val, '-1').then((res) => {
            const data = res.data;
            const billAmount = data.map((item) => item.billAmount);
            let billAmnt = 0;
            for (let i = 0; i < billAmount.length; i++) {
                billAmnt += billAmount[i];
            }
            setBillingCustodian(res.data);
            setexpensis(billAmnt);
        });
    }

    const getPaymentReqPurpose = (val) => {
        let details = { cmId: val, status: '9', requestStatus: 'JOB' }
        BillingService.getPaymentReqPurpose(details).then((res) => {
            const data = res.data;
            const reqAmount = data.map((item) => item.reqAmount);
            let reqAmnt = 0;
            for (let i = 0; i < reqAmount.length; i++) {
                reqAmnt += reqAmount[i];
            }
            setPaymentReqPurpose(res.data);
            setrequestEstimetion(reqAmnt.toFixed(2));
        });
    }

    const getAllPayment = (val) => {
        BillingService.getAllPayment(val, '-1').then((res) => {
            const data = res.data;
            const tspAmt = data.map((item) => item.tspAmt);
            let tsp = 0;
            for (let i = 0; i < tspAmt.length; i++) {
                tsp += tspAmt[i];
            }
            setAllPayment(res.data);
            setactualExpensis(tsp)
        })
    }

    const getBillingCustom = (val) => {
        BillingService.getBillingCustom(val, '-1').then((res) => {
            setBillingCustom(res.data);
        })
    }

    const getBillingSummary = (val) => {
        BillingService.getBillingSummary(val).then((res) => {
            setBillingSummary(res.data)
        })
    }

    const jobEntryAssign = (val) => {
        BillingService.getJobDetailsAssign(val).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            var MawbNo, AirlinesName, HawbNo = '';
            if (lastResult[0].transitTypeName === 'AIR') {
                MawbNo = 'MAWB.No';
                AirlinesName = 'AirlinesName';
                HawbNo = 'HAWB.No'
            } else if (lastResult[0].transitTypeName === 'SEA') {
                MawbNo = 'MBL.No';
                AirlinesName = 'ShipmentCompany';
                HawbNo = 'HBL.No'
            }
            setjobentryDetails({
                ...jobentryDetails, txt_asJobNo: lastResult[0].consignmentNumber, txt_asMawbNo: lastResult[0].wayBillNumber, txt_asImporterName: lastResult[0].importer_name,
                txt_asImporterCode: lastResult[0].importer_iec_no, txt_asImporterState: lastResult[0].deliveryStateName, ta_asimporterAddress: lastResult[0].importerAddress,
                txt_asTransitType: lastResult[0].transitTypeName, txt_asAirlinesName: lastResult[0].shipmentCompanyName, txt_asOriginCountry: lastResult[0].countryName,
                txt_asOriginPort: lastResult[0].origin_portName, txt_asClearancePort: lastResult[0].destinationName, txt_asArrivalDate: lastResult[0].expectedArrivalDateTime,
                txt_asHawbNo: lastResult[0].hawb_no, lbl_asMawbNo: MawbNo, lbl_asAirlinesName: AirlinesName, lbl_asHawbNo: HawbNo
            })
        });
    }

    //tableClick

    const EditNonUpload = (item) => {
        const selectedIndex = selected.indexOf(item.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, item.consignmentNumber);
        }
        setSelected(newSelected);
        setBillAuditValues({
            ...BillAuditValues,
            billid: '', importer: '', jobNo: '', Billname: '',
            BillPayby: '', BillPayDate: '', BillPaidto: '',
            Paymenttype: '', vouchertype: '', printedtype: '',
            RecVoucherNo: '', BillAmount: '', Remraks: '', gstprcnt: '',
        });
        setConsigment(item.consignmentNumber);
        jobEntryAssign(item.consignmentNumber);
        getBillingQuotationDetails(item.consignmentNumber);
        getBillingCustodian(item.consignmentNumber);
        getPaymentReqPurpose(item.consignmentNumber);
        getAllPayment(item.consignmentNumber);
        getBillingCustom(item.consignmentNumber);
        getBillingSummary(item.consignmentNumber);
    }
    const isSelected = (name) => selected.indexOf(name) !== -1;

    const assignCustodian = (item) => {
        console.log(' valueee' + JSON.stringify(item))
        setOpenOverAllViewJob(false)
        setUpdateDsa(false);
        setUpdate(false);
        setDeleteDsa(false);
        setDelete(false);
        var gstper = '';
        if (item.gstprcnt === '' || !item.gstprcnt) {
            gstper = ''
        } else {
            gstper = item.gstprcnt
            console.log('else in valueee' + JSON.stringify(item.gstpercent))

        }
        setBillAuditValues({
            ...BillAuditValues, billid: item.billId, Billname: item.billName,BillPrintTo:item.bill_print_to,
            BillPayby: item.unit, BillPayDate: item.billPaidDate, BillPaidto: item.rate,
            Paymenttype: item.paymentType, vouchertype: item.voucherType, printedtype: item.printedType,
            RecVoucherNo: item.paymentVoucharNo, BillAmount: item.billAmount, Remraks: item.firstLevelRemarks, gstprcnt: gstper
        });
    }

    //click
    const searchkeydown = (e) => {
        if (e.key === 'Enter') {
            getJobNoConsoleNonUpload(BillAuditValues.importer, BillAuditValues.jobNo);
        }
    }
    const validate = () => {
        if (BillAuditValues.Billname !== '') {
            if (BillAuditValues.BillPayby !== '') {
                if (BillAuditValues.Paymenttype !== '') {
                    if (BillAuditValues.vouchertype !== '') {
                        if (BillAuditValues.printedtype !== '') {
                            if (BillAuditValues.BillAmount !== '') {
                                return true;
                            }
                            else {
                                document.getElementById('billAmount').focus();
                                setBillGenError({ ...BillGenError, FirstLvl_BillAmount: true });
                                setOpen(true); setseverity('warning'); setMessage('Please Enter Billing Amount ..!!');
                            }
                        }
                        else {
                            document.getElementById('printedTyp').focus();
                            setBillGenError({ ...BillGenError, FirstLvl_printedtype: true });
                            setOpen(true); setseverity('warning'); setMessage('Please Select Payment Type ..!!');
                        }
                    }
                    else {
                        document.getElementById('vocherTyp').focus();
                        setBillGenError({ ...BillGenError, FirstLvl_vouchertype: true })
                        setOpen(true); setseverity('warning'); setMessage('Please Select Voucher Type ..!!');
                    }
                }
                else {
                    document.getElementById('PaymentTyp').focus();
                    setBillGenError({ ...BillGenError, FirstLvl_Paymenttype: true })
                    setOpen(true); setseverity('warning'); setMessage('Please Select Payment Type ..!!');
                }
            }
            else {
                document.getElementById('paidBy').focus();
                setBillGenError({ ...BillGenError, FirstLvl_BillPayby: true })
                setOpen(true); setseverity('warning'); setMessage('Please Select Bill Paid By ..!!');
            }
        }
        else {
            document.getElementById('billname').focus();
            setBillGenError({ ...BillGenError, FirstLvl_Billname: true });
            setOpen(true); setseverity('warning'); setMessage('Please Select Bill Name ..!!');
        }
        return false;
    }

    const updateCustomBilling = () => {
        if (validate() === true) {
            setUpdateDsa(true);
            setUpdate(true);
            let details = {
                billId: BillAuditValues.billid, billName: BillAuditValues.Billname, billPaidBy: BillAuditValues.BillPayby, operationType: '',
                paymentType: BillAuditValues.Paymenttype, voucherType: BillAuditValues.vouchertype, printedType: BillAuditValues.printedtype,
                billPaidDate: BillAuditValues.BillPayDate, billPaidTo: BillAuditValues.BillPaidto, billAmount: BillAuditValues.BillAmount,
                paymentVoucharNo: BillAuditValues.RecVoucherNo, createdBy: getUserId(), remarks: BillAuditValues.Remraks, gstprcnt: BillAuditValues.gstprcnt,
                bill_print_to:BillAuditValues.BillPrintTo
            }
            BillingService.update1stLevelVerification(details).then((res) => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setOpen(true); setseverity('success'); setMessage(message);
                } else {
                    setOpen(true); setseverity('error'); setMessage('Updation Failed ' + message);
                } reset();
            }).catch(error => {
                setOpen(true); setseverity('error'); setMessage('Updation Failed ' + error.message); reset();
            });
        }
    }

    const deletedOverAllBilling = () => {
        setDeleteDsa(true); setDelete(true);
        BillingService.deletedOverAllBilling(BillAuditValues.billid).then((res) => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setOpen(true); setseverity('success'); setMessage(message);
            } else {
                setOpen(true); setseverity('error'); setMessage('Failed TO Delete' + message);
            } reset();
        }).catch(error => {
            setOpen(true); setseverity('error'); setMessage('Failed To Delete' + error.message); reset();
        })
    }


    const refresh = () => {
        setBillAuditValues({
            ...BillAuditValues, billid: '', importer: '', jobNo: '', Billname: '', BillPayby: '', BillPayDate: '', BillPaidto: '',
            Paymenttype: '', vouchertype: '', printedtype: '', RecVoucherNo: '', BillAmount: '', Remraks: '', gstprcnt: ''
        });
        setConsigment('')
        setBillGenError({
            ...BillGenError, Billname: false, BillPayby: false, Paymenttype: false, vouchertype: false,
            printedtype: false, RecVoucherNo: false, BillAmount: false
        });
        getData();
        setBillingSummary([])
        setBillingQuotationDetails([])
        setBillingCustodian([])
        setAllPayment([])
        setPaymentReqPurpose([])
        setUpdateDsa(true);
        setUpdate(false);
        setDeleteDsa(true);
        setDelete(false);
    }
    const VERIFYrefresh = () => {
        setBillAuditValues({
            ...BillAuditValues, billid: '', importer: '', jobNo: '', Billname: '', BillPayby: '', BillPayDate: '', BillPaidto: '',
            Paymenttype: '', vouchertype: '', printedtype: '', RecVoucherNo: '', BillAmount: '', Remraks: '', gstprcnt: ''
        }); setConsigment('')
        setBillGenError({
            ...BillGenError, Billname: false, BillPayby: false, Paymenttype: false, vouchertype: false,
            printedtype: false, RecVoucherNo: false, BillAmount: false
        });
        setjobentryDetails({
            ...jobentryDetails, txt_asJobNo: '', txt_asMawbNo: '', txt_asImporterName: '', txt_asImporterCode: '', txt_asImporterState: '',
            ta_asimporterAddress: '', txt_asTransitType: '', txt_asAirlinesName: '', txt_asOriginCountry: '', txt_asOriginPort: '', txt_asClearancePort: '',
            txt_asArrivalDate: '', txt_asHawbNo: '', lbl_asMawbNo: 'MAWB.No', lbl_asAirlinesName: 'AirlinesName', lbl_asHawbNo: 'HAWB.No',
        });
        setquatetion(''); setexpensis(''); setactualExpensis(''); setrequestEstimetion(''); getData();
        setBillingQuotationDetails([]); setBillingCustodian([]); setPaymentReqPurpose([]); setAllPayment([]); setBillingCustom([]);
        setBillingSummary([]);
        setUpdateDsa(true);
        setUpdate(false);
        setDeleteDsa(true);
        setDelete(false);
    }

    const reset = () => {
        setBillAuditValues({
            ...BillAuditValues, billid: '', importer: '', jobNo: '', Billname: '', BillPayby: '', BillPayDate: '', BillPaidto: '',
            Paymenttype: '', vouchertype: '', printedtype: '', RecVoucherNo: '', BillAmount: '', Remraks: '', gstprcnt: '',BillPrintTo:''
        })
        setjobentryDetails({
            ...jobentryDetails, txt_asJobNo: '', txt_asMawbNo: '', txt_asImporterName: '', txt_asImporterCode: '', txt_asImporterState: '',
            ta_asimporterAddress: '', txt_asTransitType: '', txt_asAirlinesName: '', txt_asOriginCountry: '', txt_asOriginPort: '',
            txt_asClearancePort: '', txt_asArrivalDate: '', txt_asHawbNo: '', lbl_asMawbNo: 'MAWB.No', lbl_asAirlinesName: 'AirlinesName',
            lbl_asHawbNo: 'HAWB.No'
        });
        setBillGenError({
            ...BillGenError, Billname: false, BillPayby: false, Paymenttype: false, vouchertype: false,
            printedtype: false, RecVoucherNo: false, BillAmount: false
        });
        jobEntryAssign(consigmnt);
        getBillingQuotationDetails(consigmnt);
        getBillingCustodian(consigmnt);
        getPaymentReqPurpose(consigmnt);
        getAllPayment(consigmnt);
        getBillingCustom(consigmnt);
        getBillingSummary(consigmnt);
        setUpdateDsa(true);
        setUpdate(false);
        setDeleteDsa(true);
        setDelete(false);
    }

    //dialogClick
    const billVerified = () => {
        verifiedFirstBilling();
        updateChargableWeight();
    }
    const verifiedFirstBilling = () => {
        if (consigmnt !== '') {
            let Details = { consignmentId: consigmnt, status: '6', createdBy: getUserId() }
            BillingService.UploadBilling(Details).then((res) => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setOpen(true); setseverity('success'); setMessage(message);
                    setBillingQuotationDetails([]); setBillingSummary([]); setBillingCustom([]);
                } else {
                    setOpen(true); setseverity('error'); setMessage('Verification Failed ' + message);
                } VERIFYrefresh();
            }).catch(error => {
                setOpen(true); setseverity('error'); setMessage('Verification Failed ' + error.message); VERIFYrefresh();
            })
            setOpenJobBillVerified(false);
        } else {
            setOpen(true); setseverity('warning'); setMessage('Kindly Select Job No from Right Side Job table');
        }
    }
    const UnVerifiedFirstBilling = () => {
        if (consigmnt !== '') {
            let Details = { consignmentId: consigmnt, status: '7', createdBy: getUserId() }
            BillingService.UploadBilling(Details).then((res) => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setOpen(true); setseverity('success'); setMessage(message);
                    setBillingQuotationDetails([]); setBillingSummary([]); setBillingCustom([]);
                } else {
                    setOpen(true); setseverity('error'); setMessage('Unverification Failed ' + message);
                } VERIFYrefresh();
            }).catch(error => {
                setOpen(true); setseverity('error'); setMessage('Unverification Failed ' + error.message); VERIFYrefresh();
            })
            setOpenJobBillVerified(false);
        } else {
            setOpen(true); setseverity('warning'); setMessage('Kindly Select Job No from Right Side Job table');
        }
    }

    const updateChargableWeight = () => {
        let details = { flag: '2', consignmentId: consigmnt, chargeableWeight: dialogValues.chargeableWight }
        BillingService.updateChargableWeight(details).then((res) => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setOpen(true); setseverity('success'); setMessage(message);
            } else {
                setOpen(true); setseverity('error'); setMessage('Updation Failed ' + message);
            }
        }).catch(error => {
            setOpen(true); setseverity('error'); setMessage('Updation Failed ' + error.message);
        })
    }

    //handleClose/open
    const handleClose = () => {
        setOpen(false);
    }
    //table search
    const jobSrch = () => {
        return <input className="searchBoxes" style={{ width: '50%' }} onChange={(e) => { jobSrchOnChange(e.target.value) }} placeholder="Search" />
    }
    const jobSrchOnChange = (searchedVal) => {
        const FilterValues = nonUplode.filter((trns) => {
            return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
        })
        if (searchedVal.length < 1) {
            setFiltereddetails(nonUplode)
        } else {
            setFiltereddetails(FilterValues)
        }
    }

    const navigate = useNavigate();
    const BackBotton = () => {
        navigate('/2ndlvl');
    }
    const ForwordBotton = () => {
        navigate('/billSub');
    }
    return (
        <div >
            <Home /><Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
            <div style={{ paddingLeft: '100px' }}>
                <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{ textAlign: 'end' }}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
                {/* view Job */}
                <Dialog open={OpenViewJob} onClose={CloseViewJobHandle} fullWidth={true} maxWidth='lg'>
                    <DialogTitle className='p-1' style={{ backgroundColor: '#81d4fa', fontWeight: 'bolder', fontFamily: 'Times New Roman', }}><center>Job Entry Details</center></DialogTitle>
                    <ItemPap1 sx={{ height: 240 }} className='scrollbarPrime'>
                        <Row className='mt-1 p-2'>
                            <Col className='jobentrAssign' xs={4}>
                                <Row xs={5}>
                                    <Col xs={5}><label style={jobentrylablestyle}>Job.No</label></Col>
                                    <Col style={{ fontFamily: 'Times New Roman' }}><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asJobNo} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={5}><label style={jobentrylablestyle}>{jobentryDetails.lbl_asMawbNo}</label></Col>
                                    <Col style={{ fontFamily: 'Times New Roman' }}><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asMawbNo} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={5}><label style={jobentrylablestyle}>Importer Name</label></Col>
                                    <Col style={{ fontFamily: 'Times New Roman' }} ><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asImporterName} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={5}><label style={jobentrylablestyle}>Importer Code</label></Col>
                                    <Col style={{ fontFamily: 'Times New Roman' }}><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asImporterCode} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={5}><label style={jobentrylablestyle}>Importer State</label></Col>
                                    <Col className='summurry' style={{ fontFamily: 'Times New Roman' }}><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asImporterState} /></Col>
                                </Row>
                            </Col>

                            <Col className='jobentrAssign'>
                                <Row xs={5}>
                                    <Col xs={5}><label style={jobentrylablestyle}>Importer Address</label></Col>
                                    <Col className='jobentrAssign' style={{ fontFamily: 'Times New Roman' }}><textarea rows="4" cols="17" disabled className='textAreaummurry scrollbarPrime'>{':' + jobentryDetails.ta_asimporterAddress}</textarea></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={4}><label style={jobentrylablestyle}>Transit Type</label></Col>
                                    <Col className='jobentrAssign' style={{ fontFamily: 'Times New Roman' }}><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asTransitType} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={4}><label style={jobentrylablestyle}>{jobentryDetails.lbl_asAirlinesName}</label></Col>
                                    <Col className='jobentrAssign' style={{ fontFamily: 'Times New Roman' }}><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asAirlinesName} /></Col>
                                </Row>
                            </Col>
                            <Col className='jobentrAssign'>
                                <Row xs={5}>
                                    <Col xs={4}><label style={jobentrylablestyle}>Origin Country</label></Col>
                                    <Col className='jobentrAssign' style={{ fontFamily: 'Times New Roman' }}><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asOriginCountry} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={4}><label style={jobentrylablestyle}>Origin Port</label></Col>
                                    <Col className='jobentrAssign' style={{ fontFamily: 'Times New Roman' }}><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asOriginPort} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={4}><label style={jobentrylablestyle}>Clearance Port</label></Col>
                                    <Col className='jobentrAssign' style={{ fontFamily: 'Times New Roman' }}><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asClearancePort} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={4}><label style={jobentrylablestyle}>Arrival Date</label></Col>
                                    <Col className='jobentrAssign' style={{ fontFamily: 'Times New Roman' }}><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asArrivalDate} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={4}><label style={jobentrylablestyle}>{jobentryDetails.lbl_asHawbNo}</label></Col>
                                    <Col className='jobentrAssign' style={{ fontFamily: 'Times New Roman' }}><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asHawbNo} /></Col>
                                </Row>
                            </Col>
                        </Row>
                    </ItemPap1>
                </Dialog>
                {/*  */}
                <Dialog open={OpenOverAllViewJob} onClose={CloseOverAllViewJobHandle} fullWidth={true} maxWidth='md'>
                    <DialogTitle className='p-1' style={{ backgroundColor: '#81d4fa', fontWeight: 'bolder' }}><center style={{ fontFamily: 'Times New Roman' }}
                    >Over All Bill Details</center></DialogTitle>
                    <DialogContent>
                        <Paper sx={{ height: 279 }}>
                            <TableContainer sx={{ maxHeight: 279 }}>
                                <Table stickyHeader className='table table-bordered mt-3'>
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell className='p-1'>Sl</StyledTableCell>
                                            <StyledTableCell className='p-1'>Description</StyledTableCell>
                                            <StyledTableCell className='p-1'>Amount</StyledTableCell>
                                            <StyledTableCell className='p-1'>PaidBy</StyledTableCell>
                                            <StyledTableCell className='p-1'>Bill Paid Date</StyledTableCell>
                                            <StyledTableCell className='p-1'>Payment Type</StyledTableCell>
                                            <StyledTableCell className='p-1'>Vocher Type</StyledTableCell>
                                            <StyledTableCell className='p-1'>Printed Type</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {BillingCustom.map((item) => (
                                            <StyledTableRow hover key={item.serialNumber} onClick={() => assignCustodian(item)}>
                                                <StyledTableCell>{item.serialNumber}</StyledTableCell>
                                                <StyledTableCell>{item.billName}</StyledTableCell>
                                                <StyledTableCell>{item.billAmount}</StyledTableCell>
                                                <StyledTableCell>{item.billPaidBy}</StyledTableCell>
                                                <StyledTableCell>{item.billPaidDate}</StyledTableCell>
                                                <StyledTableCell>{item.paymentType}</StyledTableCell>
                                                <StyledTableCell>{item.voucherType}</StyledTableCell>
                                                <StyledTableCell>{item.printedType}</StyledTableCell>
                                            </StyledTableRow>))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </DialogContent>
                </Dialog>
                {/* billVerified */}
                <Dialog open={OpenJobBillVerified} onClose={CloseJobBillVerifiedHandle} fullWidth={true} maxWidth='sm'>
                    <DialogTitle className='p-1 bg-info' style={{ fontWeight: 'bolder' }}><center style={{ fontFamily: 'Times New Roman' }}
                    >Chargeable Weight Updation</center></DialogTitle>
                    <div >
                        <center><TextField style={{ fontFamily: 'Times New Roman' }} className='mt-2' label='Gross Wight' aria-readonly value={dialogValues.grossWight} size='small' /></center>
                        <center><TextField style={{ fontFamily: 'Times New Roman' }} className='mt-2' label='Chargeable Wight' value={dialogValues.chargeableWight} size='small'
                            onChange={chargableChangehandle} /></center>
                        <br></br>
                        <center><Button style={{ fontFamily: 'Times New Roman' }} variant='contained' size='small' color='info' onClick={billVerified}>Bill Verified</Button></center>
                        <br></br>
                        <Divider />
                    </div>
                </Dialog>
                {loading ?
                    <div className="loaderCss">
                        <HashLoader
                            color={"#296cbc"}
                            loading={loading}
                            size={50}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                    </div>
                    :
                    <Grid container>
                        <Grid item xs={2}>
                            <ItemPap3 >
                                {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small" >
                                    <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px', marginLeft: '5px' }} /> </ToggleButton> */}
                                <lable style={{ fontSize: '12px', fontWeight: 'bold', color: 'red', marginTop: '0.5%', marginBottom: '1%', marginLeft: '18px', fontFamily: 'Times New Roman', }}>Non Auditing Job</lable>
                                <TableContainer sx={{ maxHeight: 360 }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1'>Sl</StyledTableCell>
                                                <StyledTableCell className='p-1'>JobNo {jobSrch()}</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Filtereddetails.map((item) => {
                                                const isItemSelected = isSelected(item.consignmentId);
                                                return (
                                                    <TableRow hover key={item.consignmentNumber} tabIndex={-1} selected={isItemSelected} onClick={() => EditNonUpload(item)}>
                                                        <StyledTableCell className='p-1'>{item.serialNumber}</StyledTableCell>
                                                        <StyledTableCell className='p-1'>{item.consignmentNumber}</StyledTableCell>
                                                    </TableRow>)
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap3>
                        </Grid>
                        <Grid item xs={7}>
                            <ItemPap>
                                <div className=' p-1 mt-2 mb-2'>
                                    <Row>
                                        <lable style={{ fontSize: '20px', fontWeight: 'bold', color: 'red', marginBottom: '1%', fontFamily: 'Times New Roman', }}>BILL AUDITING</lable>
                                        <Col xs={1} >
                                            <label style={{ color: 'darkblue', fontWeight: 'bolder', fontFamily: 'Times New Roman', }}>JOB.NO</label>
                                        </Col>
                                        <Col xs={3}>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} type='number' onKeyDown={searchkeydown}
                                                value={BillAuditValues.jobNo} onChange={BillAudit_jobNoChangeHandle}
                                            />
                                        </Col>
                                        <Col xs={2}><label style={{ fontFamily: 'Times New Roman', color: 'darkblue', fontWeight: 'bolder' }}>IMPORTER</label></Col>
                                        <Col xs={3}>
                                            <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }}
                                                value={BillAuditValues.importer} onChange={BillAudit_importerChangeHandle}>
                                                <option value={''}></option>
                                                {DrpImporter.map((item) => (
                                                    <option value={item.importer_iec_no}>{item.importer_name}</option>
                                                ))}
                                            </Form.Select>
                                        </Col>
                                        <Col xs={1}>
                                            <label style={{ fontFamily: 'Times New Roman', color: 'darkblue', fontWeight: 'bolder' }}>JOB</label>
                                        </Col>
                                        <Col xs={2}>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', color: 'darkred', textAlign: 'center', fontWeight: 'bold' }} value={consigmnt} disabled />
                                        </Col>
                                    </Row>
                                </div>
                                <Row>
                                    <Col><label style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bolder' }}>Bill Name</label>
                                        <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} disabled required isInvalid={BillGenError.Billname}
                                            value={BillAuditValues.Billname} onChange={BillAudit_BillnameChangeHandle}>
                                            <option value={''}></option>
                                            {billName.map((item) => (
                                                <option value={item.billName}>{item.billName}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col><label style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bolder' }}>Payment Type</label>
                                        <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} required isInvalid={BillGenError.Paymenttype}
                                            value={BillAuditValues.Paymenttype} onChange={BillAudit_PaymenttypeChangeHandle}>
                                            <option value={''}></option>
                                            {billType.map((item) => (
                                                <option value={item.paymentType}>{item.paymentType}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col><label className='billingIpTitle'>Rec_VoucherNo</label>
                                        <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }}
                                            value={BillAuditValues.RecVoucherNo} onChange={BillAudit_RecVoucherNoChangeHandle} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col><label style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bolder' }}>Curruncy</label>
                                        <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} required isInvalid={BillGenError.BillPayby}
                                            value={BillAuditValues.BillPrintTo} onChange={BillAudit_BillPrintToChangeHandle}>
                                            <option value=''></option>
                                            {billPrintTo.map((item) => (
                                                <option value={item.currency_code}>{item.currency_code}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col><label style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bolder' }}>Voucher Type</label>
                                        <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} required isInvalid={BillGenError.vouchertype}
                                            value={BillAuditValues.vouchertype} onChange={BillAudit_vouchertypeChangeHandle}>
                                            <option value={''}></option>
                                            {VoucherType.map((item) => (
                                                <option value={item.voucherType}>{item.voucherType}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col xs={4} className='billingIpTitle'><label>BillPaid Date</label>
                                        <Form.Control type='date' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }}
                                            value={BillAuditValues.BillPayDate} onChange={BillAudit_BillPayDateChangeHandle} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col><label style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bolder' }}>Unit Price</label>
                                        <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }}
                                        value={BillAuditValues.BillPayby} onChange={BillAudit_BillPaybyChangeHandle} />
                                    </Col>
                                    <Col><label style={{
                                        color: 'red', fontWeight: 'bolder', fontFamily: 'Times New Roman',
                                    }}>Printed Type</label>
                                        <Form.Select size='sm' style={{
                                            fontFamily: 'Times New Roman',
                                            border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold'
                                        }} required isInvalid={BillGenError.printedtype}
                                            value={BillAuditValues.printedtype} onChange={BillAudit_printedtypeChangeHandle}>
                                            <option value={''}></option>
                                            {PrintedType.map((item) => (
                                                <option value={item.printedType}>{item.printedType}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col><label style={{
                                        fontFamily: 'Times New Roman',
                                        color: 'red', fontWeight: 'bolder'
                                    }}>Bill Amount</label>
                                        <Form.Control style={{
                                            fontFamily: 'Times New Roman',
                                            border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold'
                                        }} required isInvalid={BillGenError.BillAmount}
                                            value={BillAuditValues.BillAmount} onChange={BillAudit_BillAmountChangeHandle} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                    <label className='billingIpTitle'>Rate</label>
                                    <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }}
                                            value={BillAuditValues.BillPaidto} onChange={BillAudit_BillPaidtoChangeHandle} />
                                    </Col>
                                    <Col className='mt-1 mb-1'>
                                        <label className='billingIpTitle'>Remarks</label>

                                        <center><Form.Control style={{
                                            fontFamily: 'Times New Roman',
                                            border: '1px solid black', width: '257px', height: '26px', textAlign: 'center', fontWeight: 'bold'
                                        }}
                                            value={BillAuditValues.Remraks} onChange={BillAudit_RemraksChangeHandle} /></center>
                                    </Col>
                                    <Col>
                                        <label className='billingIpTitle'>Gst(%)</label>
                                        <center>< Form.Control id='gstid' style={{ border: '1px solid black', height: '26px', width: '257px', textAlign: 'center', fontWeight: 'bold' }}
                                            value={BillAuditValues.gstprcnt} onChange={BillAudit_gstChangeHandle} /></center>
                                    </Col>
                                </Row>
                                <div className='mt-2 form-inline'>
                                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' onClick={updateCustomBilling} disabled={UpdateDsa}>{Update ? 'processing..' : 'Update'}</Button>{' '}
                                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' color="info" onClick={deletedOverAllBilling} disabled={DeleteDsa}>{Delete ? 'processing..' : 'Delete'}</Button>{' '}
                                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' onClick={refresh}>Refresh</Button>{' '}
                                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' onClick={OpenViewJobHandle}>View_Job</Button>{' '}
                                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' onClick={OpenOverAllViewJobHandle}>View Over All Bill</Button>{' '}
                                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" color="error" className='mt-1' onClick={OpenJobBillVerifiedHandle}>Bill_Verified</Button>{' '}
                                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" color="info" className='mt-1' onClick={UnVerifiedFirstBilling}>Un Verified_Payment_Approval</Button>{' '}
                                </div>
                            </ItemPap>
                        </Grid>
                        <Grid item xs={3}>
                            <ItemPap4>
                                <lable style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'red', marginTop: '0.5%', marginBottom: '1%', marginRight: '50px' }}>Summary Details</lable>
                                {/* <ToggleButton onClick={ForwordBotton} size="small" className='headerstyleEND'>
                                    <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px' }} /> </ToggleButton> */}
                                <TableContainer sx={{ maxHeight: 360 }} className='scrollbarPrime'>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1' >Description</StyledTableCell>
                                                <StyledTableCell className='p-1' style={{ color: 'red' }}>Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {BillingSummary.map((item) => (
                                                <StyledTableRow hover key={item.billType}>
                                                    <StyledTableCell>{item.billType}</StyledTableCell>
                                                    <StyledTableCell>{item.billAmount}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap4>
                        </Grid>
                        <Grid item xs={3}>
                            <ItemPap2>
                                <StyledTableRow>
                                    <StyledTableCell className='p-1' style={{ fontWeight: 'bold', color: 'black' }}>Billing Amount From Quotation:</StyledTableCell>
                                    <StyledTableCell className='p-1' align='left' style={{ color: 'red' }}>{quatetion}</StyledTableCell>
                                </StyledTableRow>
                                <TableContainer sx={{ maxHeight: 200, backgroundColor: 'white' }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1' sx={{ width: 300 }}>Description</StyledTableCell>
                                                <StyledTableCell className='p-1' style={{ color: 'red' }}>Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {BillingQuotationDetails.map((item) => (
                                                <StyledTableRow hover key={item.billName} onClick={() => assignCustodian(item)}>
                                                    <StyledTableCell sx={{ width: 300 }}>{item.billName}</StyledTableCell>
                                                    <StyledTableCell>{item.billAmount}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap2>
                        </Grid>
                        <Grid item xs={3}>
                            <ItemPap2>
                                <StyledTableRow>
                                    <StyledTableCell className='p-1' style={{ fontWeight: 'bold', color: 'black' }}>BillingAmountFrom_Expenses:</StyledTableCell>
                                    <StyledTableCell className='p-1' align='left' style={{ color: 'red' }}>{expensis}</StyledTableCell>
                                </StyledTableRow>
                                <TableContainer sx={{ maxHeight: 200, backgroundColor: 'white' }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1' sx={{ width: 300 }}>Description</StyledTableCell>
                                                <StyledTableCell className='p-1' style={{ color: 'red' }}>Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {BillingCustodian.map((item) => (
                                                <StyledTableRow hover key={item.billName} onClick={() => assignCustodian(item)}>
                                                    <StyledTableCell sx={{ width: 300 }}>{item.billName}</StyledTableCell>
                                                    <StyledTableCell>{item.billAmount}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap2>
                        </Grid>
                        <Grid item xs={3}>
                            <ItemPap2>
                                <StyledTableRow>
                                    <StyledTableCell className='p-1' style={{ fontWeight: 'bold', color: 'black' }}>Actual/Expenses Amount:</StyledTableCell>
                                    <StyledTableCell className='p-1' align='left' style={{ color: 'red' }}>{actualExpensis}</StyledTableCell>
                                </StyledTableRow>
                                <TableContainer sx={{ maxHeight: 200, backgroundColor: 'white' }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1' sx={{ width: 300 }}>Description</StyledTableCell>
                                                <StyledTableCell className='p-1' style={{ color: 'red' }}>Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {AllPayment.map((item) => (
                                                <StyledTableRow hover key={item}>
                                                    <StyledTableCell sx={{ width: 300 }}>{item.tspPaidTo}</StyledTableCell>
                                                    <StyledTableCell>{item.tspAmt}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap2>
                        </Grid>
                        <Grid item xs={3}>
                            <ItemPap2 >
                                <StyledTableRow>
                                    <StyledTableCell className='p-1' style={{ fontWeight: 'bold', color: 'black' }}>Request/Estimation Amount:</StyledTableCell>
                                    <StyledTableCell className='p-1' align='left' style={{ color: 'red' }}>{requestEstimetion}</StyledTableCell>
                                </StyledTableRow>
                                <TableContainer sx={{ maxHeight: 200, backgroundColor: 'white' }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1' sx={{ width: 300 }}>Description</StyledTableCell>
                                                <StyledTableCell className='p-1' style={{ color: 'red' }}>Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {PaymentReqPurpose.map((item) => (
                                                <StyledTableRow hover key={item.reqPurpose}>
                                                    <StyledTableCell sx={{ width: 300 }}>{item.reqPurpose}</StyledTableCell>
                                                    <StyledTableCell>{item.reqAmount}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap2>
                        </Grid>
                    </Grid>}
            </div>
        </div>
    )
}

export default BillAuditing